(function ($) {

  $(document).ready(function () {

    $(".c-home__slider").slick({
      autoplay: true,
      autoplaySpeed: 4000,
      arrows: false,
      fade: false,
      draggable: true,
      adaptiveHeight: false,
      mobileFirst: true,
      pauseOnDotsHover: false,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    });

  });
})
(jQuery);
